import { contactInfo } from "@/mocks/site/content";

export default function ContactInfoPanel() {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
      {/* Primary info card */}
      <div className="bg-[#1A1410] text-cream-100 rounded-2xl p-7 md:p-8">
        <div className="flex items-center gap-2 mb-5 text-brand-300">
          <i className="ri-customer-service-2-line text-lg"></i>
          <span className="text-xs uppercase tracking-[0.18em] font-bold">Quick contact</span>
        </div>

        <div className="space-y-5">
          <div>
            <div className="text-[11px] uppercase tracking-[0.15em] text-cream-100/50 font-semibold mb-1.5">
              Sales &amp; Quotes
            </div>
            <a
              href={`tel:${contactInfo.phoneSales.replace(/[^\d]/g, "")}`}
              className="font-display text-2xl font-bold text-white hover:text-brand-300 transition-colors cursor-pointer block"
            >
              {contactInfo.phoneSales}
            </a>
          </div>
          <div>
            <div className="text-[11px] uppercase tracking-[0.15em] text-cream-100/50 font-semibold mb-1.5">
              Existing customers
            </div>
            <a
              href={`tel:${contactInfo.phoneSupport.replace(/[^\d]/g, "")}`}
              className="font-display text-lg font-bold text-white hover:text-brand-300 transition-colors cursor-pointer block"
            >
              {contactInfo.phoneSupport}
            </a>
          </div>
          <div>
            <div className="text-[11px] uppercase tracking-[0.15em] text-cream-100/50 font-semibold mb-1.5">
              Email
            </div>
            <a
              href={`mailto:${contactInfo.email}`}
              className="text-base font-semibold text-white hover:text-brand-300 transition-colors cursor-pointer break-all"
            >
              {contactInfo.email}
            </a>
          </div>
        </div>

        <div className="mt-7 pt-6 border-t border-white/10">
          <div className="text-[11px] uppercase tracking-[0.15em] text-cream-100/50 font-semibold mb-3">
            Hours
          </div>
          <ul className="space-y-2 text-sm">
            {contactInfo.hours.map((h) => (
              <li key={h.day} className="flex items-center justify-between">
                <span className="text-cream-100/80">{h.day}</span>
                <span className="font-semibold text-white">{h.time}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>

      {/* Address */}
      <div className="bg-white rounded-2xl p-6 border border-ink-100">
        <div className="flex items-center gap-2 mb-3 text-brand-600">
          <i className="ri-map-pin-line text-lg"></i>
          <span className="text-xs uppercase tracking-[0.18em] font-bold">Office &amp; Warehouse</span>
        </div>
        <p className="text-sm text-ink-700 leading-relaxed mb-4">{contactInfo.address}</p>
        <div className="rounded-lg overflow-hidden h-44 border border-ink-100">
          <iframe
            title="Haulmark Movers office location"
            src="https://www.google.com/maps?q=412+Industry+Court+Brooklyn+NY&output=embed"
            className="w-full h-full"
            loading="lazy"
          ></iframe>
        </div>
      </div>

      {/* Service areas */}
      <div className="bg-white rounded-2xl p-6 border border-ink-100">
        <div className="flex items-center gap-2 mb-4 text-brand-600">
          <i className="ri-road-map-line text-lg"></i>
          <span className="text-xs uppercase tracking-[0.18em] font-bold">Service areas</span>
        </div>
        <div className="flex flex-wrap gap-1.5">
          {contactInfo.serviceAreas.map((area) => (
            <span
              key={area}
              className="px-2.5 py-1 rounded-md bg-cream-100 text-xs font-semibold text-ink-700"
            >
              {area}
            </span>
          ))}
        </div>
        <p className="text-xs text-ink-500 mt-4 leading-relaxed">
          + long-distance moves anywhere in the continental US.
        </p>
      </div>
    </div>
  );
}